/**
 * Separator used to delimit plugin name from feature key in app_feature names.
 * e.g. "MyPlugin::dashboard"
 */
export const PLUGIN_SEPARATOR = "::";

const VALID_KEY_PATTERN = /^[a-zA-Z0-9_-]+$/;

const VALID_PERMISSIONS = new Set(["read", "create", "update", "delete"]);

/**
 * Extracts and validates the features array from a loaded plugin module.
 *
 * @param {Object} pluginModule - The module returned from importRemote (expects pluginModule.default.features)
 * @returns {Array<{key: string, label: string, allowed_permissions: string[]}>} Validated, deduplicated features (may be empty)
 */
export function extractPluginFeatures(pluginModule) {
  const moduleDefault = pluginModule?.default;
  const features = moduleDefault?.features;

  if (!Array.isArray(features)) {
    return [];
  }

  const seen = new Set();

  return features
    .filter((f) => {
      if (!f || typeof f.key !== "string" || typeof f.label !== "string") {
        return false;
      }

      const key = f.key.trim();
      const label = f.label.trim();

      if (!key || !label || !VALID_KEY_PATTERN.test(key)) {
        return false;
      }

      if (seen.has(key)) {
        return false;
      }

      seen.add(key);
      return true;
    })
    .map((f) => {
      // Validate and normalize allowed_permissions
      let allowedPermissions = ["read"]; // default fallback
      if (Array.isArray(f.allowed_permissions) && f.allowed_permissions.length > 0) {
        allowedPermissions = f.allowed_permissions.filter(
          (p) => typeof p === "string" && VALID_PERMISSIONS.has(p)
        );
        if (allowedPermissions.length === 0) {
          allowedPermissions = ["read"];
        }
      }

      return {
        key: f.key.trim(),
        label: f.label.trim(),
        allowed_permissions: allowedPermissions,
      };
    });
}
